import { Grade } from './grade'
import { Clazz } from './clazz'
import { Drill } from './drill'
import { Student } from './student'
import { IQueryMultiplePagination } from './query'
import { HomeworkStudentSmartCheck } from './homework'

export enum HomeworkStatsType {
  ByGrade = 'byGrade',
  ByClazz = 'byClazz',
  ByDrill = 'byDrill',
  ByClock = 'byClock',
  ByStudent = 'byStudent',
}

export enum HomeworkStatsPeriodType {
  Daily = 'daily',
  Weekly = 'weekly',
}

export interface IHomeworkStatsParam {
  type: HomeworkStatsType
  icon: string
  title: string
  query: IQueryMultiplePagination
  periodType?: HomeworkStatsPeriodType
  description: string
}

export interface IHomeworkStatByGradeByClazzBase {
  homework_count: number
  total_duration: number
  avg_duration: number
  total_play_count: number
  avg_play_count: number
  student_count: number
  exceptional_count: number
  completed_student_count: number
  participated_student_count: number
}

export interface IHomeworkStatByGradeBase extends IHomeworkStatByGradeByClazzBase {
  grade: Grade
}

export interface IHomeworkStatByGradeDaily extends IHomeworkStatByGradeBase {
  homework_date: string
}

export interface IHomeworkStatByGradeWeekly extends IHomeworkStatByGradeBase {
  homework_start_date: string
  homework_end_date: string
}

export interface IHomeworkStatByClazzBase extends IHomeworkStatByGradeByClazzBase {
  clazz: Clazz
}

export interface IHomeworkStatByClazzDaily extends IHomeworkStatByClazzBase {
  homework_date: string
}

export interface IHomeworkStatByClazzWeekly extends IHomeworkStatByClazzBase {
  homework_start_date: string
  homework_end_date: string
}

export interface IHomeworkStatByStudentBase {
  clazz: Clazz
  student: Student
  total_duration: number
  homework_item_count: number
  completed_item_count: number
}

export interface IHomeworkStatByStudentDaily {
  homework_type: string
  homework_date: string
  status: string
  ai_detection: HomeworkStudentSmartCheck
  completed_at: string
}

export interface IHomeworkStatByStudentWeekly {
  homework_types: string[]
  homework_count: number
  completed_homework_count: number
  homework_start_date: string
  homework_end_date: string
}

export interface IHomeworkStatByClock {
  clazz: Clazz
  student: Student
  homework_count: number
  done_count: number
  un_start_count: number
  uncompleted_count: number
  exceptional_count: number
  delayed_done_count: number
  status_by_day: Array<{
    date: string
    status: string
    rating: string | null
  }>
}

export interface IHomeworkStatByDrill {
  clazz: Clazz
  student: Student
  drill: Drill
  completed_at: string
  ai_detection: HomeworkStudentSmartCheck
  play_duration: number
  rating: string
  score: number
}
